// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\EmailSettingsResponse

import { SurveyEmailCondition } from './enums.gen';

export type EmailSettingsApiResponse = {
	id: number;
	showLogo: boolean;
	logo: string | null;
	banner: string | null;
	headerText: string;
	footerText: string;
	customContent: Record<string, string>;
	surveyEmailCondition: SurveyEmailCondition;
	sendBookingReminder: boolean;
	minutesBeforeBookingReminder: number;
};

export type EmailSettings = {
	id: number;
	showLogo: boolean;
	logo: string | null;
	banner: string | null;
	headerText: string;
	footerText: string;
	customContent: Record<string, string>;
	surveyEmailCondition: SurveyEmailCondition;
	sendBookingReminder: boolean;
	minutesBeforeBookingReminder: number;
};

export function hydrateEmailSettings(data: EmailSettingsApiResponse): EmailSettings {
	return {
		...data,
		customContent: Array.isArray(data.customContent) ? {} : data.customContent,
	};
}